import {Injectable} from '@angular/core';
import {Params} from '@angular/router';
import {BehaviorSubject} from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ClientEnvService {
  isStripped = false;
  isMobile = false;
  anchorTarget: string = window.top !== window.self ? '_self' : '_blank';
  clientOS: string;
  private ready = false;
  public sidebarModuleSubject$: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);

  constructor() {}

  setup(queryParams: Params): void {
    if (this.ready) {
      return;
    }

    this.ready = true;
    this.isStripped = Boolean(typeof queryParams.stripped !== 'undefined');
    this.isMobile = Boolean(
      window.navigator.userAgent.match(
        /Android|BlackBerry|iPhone|iPad|iPod|Opera Mini|IEMobile|FxiOS/i
      )
    );
    const body = document.body as HTMLElement;

    this.clientOS = window.navigator.userAgent.match(/Macintosh/i) ? 'Macintosh' : '';

    if (this.isStripped) {
      body.classList.add('is-stripped');
    }

    if (this.isMobile) {
      body.classList.add('is-mobile');
    }
  }
}
